// internal dependencies
import { showToast } from "../toasts";
import { setDateFilter } from "./common/set-input-filter";
import { getInitalTransactionData } from "./data/get-transactions";
import { displayTransactionTable } from "./display/display-transactions";
import { transactionTableFilter } from "./filters/transaction-filter";
import { setDownloadDropDown } from "./download/set-download-dropdown";
import { downloadTransactionData } from "./download/transaction-download";

/**
 * Transaction Table Main
 * This function initializes and manages the transaction table and rated functionalities.
 * 
 * @returns void
 */
const TransactionTable = async (): Promise<void> => {
  const transactionTable = document.querySelector(".aafp_transaction-list") as HTMLElement | null;
  if (!transactionTable) return;

  const startDate: Date = setDateFilter();
  const endDate: Date = new Date();
  const transactionData = await getInitalTransactionData(startDate, endDate);

  if (transactionData.length === 0) {
    showToast("aafp_toast-alert", "Error fetching transaction data. Please try again later.");
    return;
  }

  const tableObject = displayTransactionTable(transactionTable, transactionData);
  await transactionTableFilter(tableObject, startDate, endDate);
  const currentMonth = setDownloadDropDown();
  downloadTransactionData(tableObject, currentMonth);
};

export default TransactionTable;